import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
'use strict';

const menu = {
	init: function() {
		gsap.registerPlugin(ScrollTrigger);

		const triggers = ["qui-sommes-nous", "interlocuteurs", "contact"];
		triggers.forEach(trigger => {
			let menuItem = document.querySelectorAll('.header__nav__list__link[data-anchor="'+trigger+'"]');
			let contentItem = document.querySelectorAll('#'+trigger);
			if( menuItem.length && contentItem.length ){
				gsap.to(contentItem[0], {
					scrollTrigger: {
						trigger: contentItem[0],
						start: 'top+=150px center',
						onEnter: () => {
							menuItem[0].classList.add('active');
						},
						onLeaveBack: () => {
							menuItem[0].classList.remove('active');
						},
					}
				});
			}
		})
	},
}

window.addEventListener('DOMContentLoaded', function() {
	if( document.querySelectorAll('header .header').length ) {
		menu.init();
	}
});